<template>
    <div class="m-2">
        <AlertDismiss  ref="alertDismiss" class="mt-2"/>
        <b-form @submit.prevent="onSubmit" autocomplete="off">
            <PasswordInput label="Contraseña actual" v-model="oldPassword" class="mb-3"/>
            <PasswordInput label="Nueva contraseña" v-model="newPassword" class="mb-3"/>
            <PasswordInput label="Confirmar nueva contraseña" v-model="confirmNewPassword" class="mb-3"/>
            <b-button type="submit" variant="primary" class="mt-2">
                <b-spinner small v-if="uploading"/>
                Cambiar contraseña
            </b-button>
        </b-form>
    </div>
</template>

<script>
import AlertDismiss from "@/components/shared/Alert-dismiss.vue";
import PasswordInput from "@/components/shared/Password-input.vue";
import { mapActions } from "vuex";

export default {
    name: "UpdatePasswordForm",
    components: {
        AlertDismiss,
        PasswordInput
    },

    data() {
        return {
            oldPassword: "",
            newPassword: "",
            confirmNewPassword: "",
            uploading: false,
        }
    },

    methods: {
        ...mapActions(["changePassword"]),

        async onSubmit() {
            if (this.newPassword !== this.confirmNewPassword) {
                this.$refs.alertDismiss.showAlert('Confirmación de contraseña no coinciden', 'warning');
                return;
            }
            this.uploading = true;

            let result = await this.changePassword({
                oldPassword: this.oldPassword,
                newPassword: this.newPassword,
                confirmNewPassword: this.confirmNewPassword
            });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message, 'warning');
                this.uploading = false;
                return;
            }

            this.$refs.alertDismiss.showAlert("Contraseña actualizada con éxito", 'success');
            this.uploading = false;
            await this.clearForm();
        },
        async clearForm() {
            this.oldPassword = "";
            this.newPassword = "";
            this.confirmNewPassword = "";
        },
    }
}
</script>
